<template>
  <div class="checkbox-filter">
    <no-ssr>
      <b-form-group>
        <b-form-radio-group
          v-model="currentSelected"
          class="single-item"
          text-field="label"
          :options="options"
          :name="inputName"
        ></b-form-radio-group>
      </b-form-group>
    </no-ssr>
  </div>
</template>

<script>
export default {
  props: {
    attrCode: {
      type: String,
      required: true
    },
    options: {
      type: Array,
      required: true
    },
    optionSelected: {
      type: String | Number,
      required: false
    },
    radioName: {
      type: String,
      required: false
    }
  },
  computed: {
    currentSelected: {
      get () {
        return this.optionSelected
      },
      set (newValues) {
        this.$emit('changeFilter', this.getFilterCompose(newValues))
        return newValues
      }
    },
    inputName () {
      if (this.radioName) {
        return `radio-${this.radioName}-${this.attrCode}`
      } else {
        return `radio-${this.attrCode}`
      }
    }
  },
  methods: {
    getFilterCompose (newValues) {
      return { attrCode: this.attrCode, valueSelected: newValues }
    }
  }
}
</script>
